// extracted by mini-css-extract-plugin
export default {"wrapper":"Forbidden_wrapper__Z1a1J","title":"Forbidden_title__dMq8D","text":"Forbidden_text__aD5kc","btn":"Forbidden_btn__UBz8a"};